export type OmsPresetRetryIdentity = {
  identity: string;
  id: string;
  attemptedAt?: number;
};

const guarantee = 24 * 60 * 60 * 1000;

export function presetRetryExpired(
  request: OmsPresetRetryIdentity,
  now = Date.now()
): boolean {
  return (
    request.attemptedAt === undefined ||
    !Number.isFinite(request.attemptedAt) ||
    request.attemptedAt > now ||
    now - request.attemptedAt >= guarantee
  );
}

export class PresetRetryExpiredError extends Error {
  constructor(readonly requestId: string, readonly reconciled: boolean) {
    super(
      reconciled
        ? "The earlier request is outside the 24-hour retry window and may have completed. Your preset list has been refreshed. Check existing presets before starting a new request."
        : "The earlier request is outside the 24-hour retry window. Could not refresh your presets; retry to check them before starting a new request."
    );
    this.name = "PresetRetryExpiredError";
  }
}
